import { render, staticRenderFns } from "./BusinessSLR.vue?vue&type=template&id=277996d1&scoped=true&"
import script from "./BusinessSLR.vue?vue&type=script&lang=ts&"
export * from "./BusinessSLR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277996d1",
  null
  
)

export default component.exports